import styled from "@emotion/styled";

export const AccountAdminsContainer = styled.div(({ theme }) => ({
	...theme.project.typography.alert.alertTitle,
	color: theme.project.colors.fontColors.main
}));

export const UserPermissionsInfoContainer = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: "8px"
});
